import React from 'react';
import { ReadBookmark } from '@/infrastructure/class/read-bookmark';
import s from './styles.module.scss';
import { routes } from '@/infrastructure/const/routes';
import { useRouter } from 'next/router';
import ReadSurahsListItemMenuBtn from '../../menu-btn';
import { useTranslation } from 'next-i18next';
import { ImportContactsRounded } from '@mui/icons-material/';
import OpenButton from '@/components/buttons/open';

interface IReadBookmarksCarouselItemProps {
  data: ReadBookmark;
}

const ReadBookmarksCarouselItem: React.FC<IReadBookmarksCarouselItemProps> = (
  props
) => {
  const { data } = props;

  const { t: tButtons } = useTranslation('buttons');
  const { t: tCommon } = useTranslation('common');

  const router = useRouter();

  const handleClick = () => {
    let url = `${routes.surahRead}/${data.readSurah?.slug}`;
    if (data.ayaIndex) url = url + `?number=${data.ayaIndex}`;
    router.push(url);
  };

  return (
    <div className={s['card']}>
      <p className={s['icon']}>
        <ImportContactsRounded fontSize="inherit" />
      </p>
      <div className={s['info']}>
        <p className={s['title']}>
          {data.readSurah?.titleEn}
          <br />
          <span className={s['ar']}>{data.suraAName}</span>
        </p>
        <p className={s['subtitle']}>
          <span>{`${tCommon('page')} ${data.page} `}</span>
          <span>{`${tCommon('surah')} ${data.suraIndex} `}</span>
          <span>{`${tCommon('ayah')} ${data.ayaIndex} `}</span>
        </p>
      </div>
      <div className={s['controls']}>
        <OpenButton
          onClick={handleClick}
          text={data.isLastRead ? tButtons('returnToReading') : undefined}
        />
        {data.readSurah && (
          <ReadSurahsListItemMenuBtn
            className={s['menu-btn']}
            data={data.readSurah}
          />
        )}
      </div>
    </div>
  );
};

export default ReadBookmarksCarouselItem;
